/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'flickr': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#e12c92" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M15.211 15.64a5.647 5.647 0 11-11.293 0 5.647 5.647 0 0111.293 0zM28.083 16.36a5.647 5.647 0 11-11.293 0 5.647 5.647 0 0111.293 0z"/>'
  }
})
